import styled from 'styled-components'

import { useUnitTranslate } from 'aem-libs-react-ts/src/hooks/useUnitTranslate'
import type { InputUnitType } from 'aem-libs-react-ts/src/utils/unitType'
import type { Maybe } from 'aem-libs-ts/src/types/utility'
import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'
import { numberFormat } from 'aem-libs-ts/src/utils/formatting/numbers/numberFormat'

import { MEDIA_QUERY } from '../../../../../styles'
import { CsCountUp } from '../../../../common/count-up'
import { AriaHiddenLabel } from '../../../../utility/hidden-aria/HiddenAriaLabel.styled'
import { Activity } from 'react'

const Unit = styled.span`
  padding-left: 5px;
`

const ValueStyled = styled.div`
  font-weight: 700;
  font-size: 22px;

  > span {
    white-space: nowrap;
  }

  @media ${MEDIA_QUERY.MOBILE} {
    font-size: 20px;
  }
`

export interface ResultAnimatedValueProps {
  value: Maybe<number>
  unitType?: InputUnitType
  skipAnimation?: boolean
  unitCustom?: string
  className?: string
  testId?: string
  ariaLabel?: string
}

export const ResultAnimatedValue = ({
  value,
  unitType,
  unitCustom,
  className,
  skipAnimation,
  testId,
  ariaLabel
}: ResultAnimatedValueProps) => {
  const unit = useUnitTranslate(value, unitType, unitCustom)

  return (
    <div>
      <ValueStyled className={className} data-testid={testId ?? 'result-animated-value'} aria-hidden={true}>
        <Activity mode={isDefined(value) && !skipAnimation ? 'visible' : 'hidden'}>
          <CsCountUp start={value as number} end={value as number} formatter={numberFormat} firstDuration={0.5} />
        </Activity>
        {isDefined(value) && skipAnimation && numberFormat(value)}
        {unit && <Unit>{unit}</Unit>}
      </ValueStyled>
      <div>
        {ariaLabel && (
          <AriaHiddenLabel data-testid='result-animated-value--accessibility'>
            {value} {unit}
          </AriaHiddenLabel>
        )}
      </div>
    </div>
  )
}
